import classes from './expire-date-modal.module.scss';
import { userManagementService } from '../../../../../../Services';
import { Notification } from '../../../../../../utils';
import { useUserManagement } from '../../../../../../Hooks';
import { useWatch } from 'antd/es/form/Form';
import { useEffect } from 'react';
import { useProfileContext } from '../../../../../../contexts/profile.context';

import { RiTimerLine } from 'react-icons/ri';
import { DatePicker, Form, Modal } from "antd";
import { useTranslation } from 'react-i18next';

interface IForm {
  expireDate: Date;
}

interface IProps {
  expiryDateModalUserId?: string;
  userManagement: ReturnType<typeof useUserManagement>;
}

export default function ExpireDateModal(props: IProps) {
  const { t } = useTranslation();
  const [form] = Form.useForm<IForm>();
  const expireDate = useWatch(['expireDate'], form);
  const profileCtx = useProfileContext();

  const submitHandler = async () => {
    try {
      const userId = profileCtx.userInfo.value?.id;

      if (!userId || !props.expiryDateModalUserId) {
        return;
      }

      const values = await form.validateFields();
      props.userManagement.setExpiryDateModalUserId(props.expiryDateModalUserId);
      await userManagementService.setExpiryDate(props.expiryDateModalUserId, values.expireDate);
      Notification.success({ description: t('notifications.expiry-updated') });
    } catch (error) {
      Notification.error({ description: t('notifications.expiry-update-failed') })
    }

    try {
      props.userManagement.fetchUsers();
    } catch {
      Notification.error({ description: t('notifications.users-fetch-failed') })
    }
  };

  useEffect(() => {
    form.resetFields();
  }, [props.expiryDateModalUserId])

  return (
    <Modal
      title={<>
        <p>{t('settings.user-management.setting-expiry-title')}</p>
        <p>{t('settings.user-management.setting-expiry-description')}</p>
      </>}
      className={classes.modal}
      open={!!props.expiryDateModalUserId}
      onOk={submitHandler}
      okButtonProps={{ disabled: !expireDate }}
      okText={<span><RiTimerLine size={18} /> {t('settings.user-management.set-expiry')}</span>}
      cancelButtonProps={{ style: { display: 'none' } }}
      onCancel={() => props.userManagement.setExpiryDateModalUserId()}
    >
      <Form<IForm>
        name="dateExpiryForm"
        autoComplete="off"
        disabled={false}
        requiredMark={false}
        layout="vertical"
        form={form}
      >
        <Form.Item
          name="expireDate"
          label={t('settings.user-management.expire-date')}
          rules={[{ required: true, message: t('settings.user-management.expire-date-required') }]}
        >
          <DatePicker showTime />
        </Form.Item>
      </Form>
    </Modal>
  )
}